import React from 'react';
import './plan.css';

const CompactSubscriptionPlans = () => {
  return (
    <div className="ll-subscription-wrapper">
      <div className="ll-subscription-header">
        <span className="ll-beta-tag">BETA TESTING PROGRAM</span>
        <h1 className="ll-subscription-heading">Choose Your Beta Access Plan</h1>
        <p className="ll-beta-description">Join our exclusive beta program and help shape the future of language learning</p>
      </div>
      
      <div className="ll-plans-grid">
        {/* Explorer Plan (Free) */}
        <div className="ll-plan-card ll-plan-card--free">
          <div className="ll-beta-badge">BETA</div>
          
          <div className="ll-plan-header">
            <div className="ll-plan-icon-container">
            <svg class="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="27" height="27" fill="currentColor" viewBox="0 0 24 24">
  <path d="M11 9a1 1 0 1 1 2 0 1 1 0 0 1-2 0Z"/>
  <path fill-rule="evenodd" d="M9.896 3.051a2.681 2.681 0 0 1 4.208 0c.147.186.38.282.615.255a2.681 2.681 0 0 1 2.976 2.975.681.681 0 0 0 .254.615 2.681 2.681 0 0 1 0 4.208.682.682 0 0 0-.254.615 2.681 2.681 0 0 1-2.976 2.976.681.681 0 0 0-.615.254 2.682 2.682 0 0 1-4.208 0 .681.681 0 0 0-.614-.255 2.681 2.681 0 0 1-2.976-2.975.681.681 0 0 0-.255-.615 2.681 2.681 0 0 1 0-4.208.681.681 0 0 0 .255-.615 2.681 2.681 0 0 1 2.976-2.975.681.681 0 0 0 .614-.255ZM12 6a3 3 0 1 0 0 6 3 3 0 0 0 0-6Z" clip-rule="evenodd"/>
  <path d="M5.395 15.055 4.07 19a1 1 0 0 0 1.264 1.267l1.95-.65 1.144 1.707A1 1 0 0 0 10.2 21.1l1.12-3.18a4.641 4.641 0 0 1-2.515-1.208 4.667 4.667 0 0 1-3.411-1.656Zm7.269 2.867 1.12 3.177a1 1 0 0 0 1.773.224l1.144-1.707 1.95.65A1 1 0 0 0 19.915 19l-1.32-3.93a4.667 4.667 0 0 1-3.4 1.642 4.643 4.643 0 0 1-2.53 1.21Z"/>
</svg>

            </div>
            
            <div className="ll-plan-title-price">
              <h2>Explorer Plan</h2>
              <div className="ll-plan-price">$0<span className="ll-price-period">/month</span></div>
            </div>
          </div>
          
          <div className="ll-plan-divider"></div>
          
          <div className="ll-plan-description">
            <strong>Explorer</strong> gives you a taste of our innovative language learning scenarios
          </div>
          
          <div className="ll-plan-divider"></div>
          
          <div className="ll-features-list">
            <div className="ll-feature-item">
              <div className="ll-feature-check">✓</div>
              <span>Up to 5 scenarios per day</span>
            </div>
            <div className="ll-feature-item">
              <div className="ll-feature-check">✓</div>
              <span>Early access to core features</span>
            </div>
            <div className="ll-feature-item">
              <div className="ll-feature-check">✓</div>
              <span>Basic prompt customization</span>
            </div>
          </div>
          
          <div className="ll-button-container">
            <button className="ll-plan-button ll-plan-button--current">Current plan</button>
            <button className="ll-plan-button ll-plan-button--manage">Manage</button>
          </div>
        </div>
        
        {/* Pioneer Plan (Standard) */}
        <div className="ll-plan-card ll-plan-card--standard">
          <div className="ll-beta-badge">BETA</div>
          <div className="ll-recommended-badge">RECOMMENDED</div>
          
          <div className="ll-plan-header">
            <div className="ll-plan-icon-container">
            <svg class="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="26" height="26" fill="currentColor" viewBox="0 0 24 24">
  <path fill-rule="evenodd" d="M11.644 3.066a1 1 0 0 1 .712 0l7 2.666A1 1 0 0 1 20 6.68a17.694 17.694 0 0 1-2.023 7.98 17.406 17.406 0 0 1-5.402 6.158 1 1 0 0 1-1.15 0 17.405 17.405 0 0 1-5.403-6.157A17.695 17.695 0 0 1 4 6.68a1 1 0 0 1 .644-.949l7-2.666Zm4.014 7.187a1 1 0 0 0-1.316-1.506l-3.296 2.884-.839-.838a1 1 0 0 0-1.414 1.414l1.5 1.5a1 1 0 0 0 1.366.046l4-3.5Z" clip-rule="evenodd"/>
</svg>


            </div>
            
            <div className="ll-plan-title-price">
              <h2>Pioneer Plan</h2>
              <div className="ll-plan-price">$5.99<span className="ll-price-period">/month</span></div>
            </div>
          </div>
          
          <div className="ll-plan-divider"></div>
          
          <div className="ll-plan-description">
            <strong>Pioneer</strong> unlocks expanded creative capabilities with priority access to new beta features
          </div>
          
          <div className="ll-plan-divider"></div>
          
          <div className="ll-features-list">
            <div className="ll-feature-item">
              <div className="ll-feature-check">✓</div>
              <span>Unlimited scenario generation</span>
            </div>
            <div className="ll-feature-item">
              <div className="ll-feature-check">✓</div>
              <span>Up to 10 languages for practice</span>
            </div>
            <div className="ll-feature-item">
              <div className="ll-feature-check">✓</div>
              <span>Advanced prompt customization</span>
            </div>
            <div className="ll-feature-item">
              <div className="ll-feature-check">✓</div>
              <span>Priority beta feature access</span>
            </div>
          </div>
          
          <button className="ll-plan-button ll-plan-button--upgrade">Get Pioneer Access</button>
        </div>
        
        {/* Innovator Plan (Premium) */}
        <div className="ll-plan-card ll-plan-card--premium">
          <div className="ll-beta-badge">BETA</div>
          
          <div className="ll-plan-header">
            <div className="ll-plan-icon-container">
            <svg class="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="26" height="26" fill="none" viewBox="0 0 24 24">
  <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m8.032 12 1.984 1.984 4.96-4.96m4.55 5.272.893-.893a1.984 1.984 0 0 0 0-2.806l-.893-.893a1.984 1.984 0 0 1-.581-1.403V7.04a1.984 1.984 0 0 0-1.984-1.984h-1.262a1.983 1.983 0 0 1-1.403-.581l-.893-.893a1.984 1.984 0 0 0-2.806 0l-.893.893a1.984 1.984 0 0 1-1.403.581H7.04A1.984 1.984 0 0 0 5.055 7.04v1.262c0 .527-.209 1.031-.581 1.403l-.893.893a1.984 1.984 0 0 0 0 2.806l.893.893c.372.372.581.876.581 1.403v1.262a1.984 1.984 0 0 0 1.984 1.984h1.262c.527 0 1.031.209 1.403.581l.893.893a1.984 1.984 0 0 0 2.806 0l.893-.893a1.985 1.985 0 0 1 1.403-.581h1.262a1.984 1.984 0 0 0 1.984-1.984V15.7c0-.527.209-1.031.581-1.403Z"/>
</svg>


            </div>
            
            <div className="ll-plan-title-price">
              <h2>Innovator Plan</h2>
              <div className="ll-plan-price">$7.99<span className="ll-price-period">/month</span></div>
              <div className="ll-price-note">30% off during beta</div>
            </div>
          </div>
          
          <div className="ll-plan-divider"></div>
          
          <div className="ll-plan-description">
            <strong>Innovator</strong> delivers our most advanced learning experience with direct access to our development team
          </div>
          
          <div className="ll-plan-divider"></div>
          
          <div className="ll-features-list">
            <div className="ll-feature-item">
              <div className="ll-feature-check">✓</div>
              <span>Unlimited scenario generation</span>
            </div>
            <div className="ll-feature-item">
              <div className="ll-feature-check">✓</div>
              <span>Faster response times</span>
            </div>
            <div className="ll-feature-item">
              <div className="ll-feature-check">✓</div>
              <span>Access to all 25+ languages</span>
            </div>
            <div className="ll-feature-item">
              <div className="ll-feature-check">✓</div>
              <span>Up to 5 concurrent generations</span>
            </div>
            <div className="ll-feature-item">
              <div className="ll-feature-check">✓</div>
              <span>Monthly feedback sessions with developers</span>
            </div>
          </div>
          
          <button className="ll-plan-button ll-plan-button--upgrade">Get Innovator Access</button>
        </div>
      </div>
      
      <div className="ll-beta-footer">
        <p>All beta plans include a 7-day satisfaction guarantee. Help us improve by providing feedback!</p>
      </div>
    </div>
  );
};

export default CompactSubscriptionPlans;